import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
const json = require("json!./../../../../../resources/properties.json");

@Injectable()
export class TransactionReturnService {
    private _verifyTransactionUrl = '/transactions/verifyTransaction';
    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    verifyTransaction(transactionKey: string) {
        console.log("IN Transaction Return Service -> VerifyTransaction");
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        let options = new RequestOptions({ headers: authHeader, body: "" });
        console.log("URL:");
        console.log(this.serverURL + this._verifyTransactionUrl + "/" + transactionKey);                
        return this.http.get(this.serverURL + this._verifyTransactionUrl + "/" + transactionKey, options).toPromise().then(res => {
            console.log("INSIDE RESPONSE");
            console.log(res);
            return JSON.parse(res.text());
        }, this.handleError);        
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
    }

}





/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/transaction_return/transaction-return.service.ts
 **/